import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 2,
  style: {
    "margin": "16px"
  }
};
import { onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import FetchHelper from '../../utils/helper/fetch-helper';
import dayjs from 'dayjs';
import { Toast, showLoadingToast, showSuccessToast, showToast } from 'vant';
const rootCode = '513233';
export default {
  __name: 'index',
  setup(__props) {
    var _route$params, _route$params2;
    const route = useRoute();
    const router = useRouter();
    const id = route === null || route === void 0 || (_route$params = route.params) === null || _route$params === void 0 ? void 0 : _route$params.id;
    const type = route === null || route === void 0 || (_route$params2 = route.params) === null || _route$params2 === void 0 ? void 0 : _route$params2.type;
    console.log(type);
    const formValue = ref({});
    const showClsjPicker = ref(false);
    const showTownPicker = ref(false);
    const showVillagePicker = ref(false);
    const townColumns = ref([]);
    const villageColumns = ref([]);
    const fileList = ref([]);
    onMounted(() => {
      if (id && id !== 'new') {
        FetchHelper.getJson(`/h5api/cltb/yakCltb/${id}`).then(resp => {
          if (resp.data) {
            var _resp$data$areaCode, _resp$data$areaCode2, _resp$data;
            let townCode, villageCode;
            if (((_resp$data$areaCode = resp.data.areaCode) === null || _resp$data$areaCode === void 0 ? void 0 : _resp$data$areaCode.length) === 12) {
              townCode = resp.data.areaCode.substring(0, 9);
              villageCode = resp.data.areaCode;
            } else if (((_resp$data$areaCode2 = resp.data.areaCode) === null || _resp$data$areaCode2 === void 0 ? void 0 : _resp$data$areaCode2.length) === 9) {
              townCode = resp.data.areaCode;
            }
            if (townCode) {
              FetchHelper.getJson(`/h5api/area/geo/${townCode}000`).then(resp => {
                if (resp.data) {
                  formValue.value.townCode = townCode;
                  formValue.value.townName = resp.data.name;
                }
              });
            }
            if (villageCode) {
              FetchHelper.getJson(`/h5api/area/geo/${villageCode}`).then(resp => {
                if (resp.data) {
                  formValue.value.villageCode = villageCode;
                  formValue.value.villageName = resp.data.name;
                }
              });
            }
            formValue.value = {
              ...resp.data
            };
            fileList.value = (_resp$data = resp.data) === null || _resp$data === void 0 || (_resp$data = _resp$data.img) === null || _resp$data === void 0 || (_resp$data = _resp$data.split(',')) === null || _resp$data === void 0 ? void 0 : _resp$data.map(url => {
              return {
                url
              };
            });
          }
        });
      }
      FetchHelper.getJson(`/h5api/area/child/${rootCode}`).then(resp => {
        var _resp$data2;
        if ((_resp$data2 = resp.data) !== null && _resp$data2 !== void 0 && _resp$data2.length) {
          var _resp$data3;
          townColumns.value = (_resp$data3 = resp.data) === null || _resp$data3 === void 0 ? void 0 : _resp$data3.map(item => {
            return {
              text: item.name,
              value: item.shortCode
            };
          });
        }
      });
    });
    const afterRead = file => {
      file.status = 'uploading';
      file.message = '上传中...';
      const formData = new FormData();
      formData.append('file', file.file);
      console.log(`output->file`, file);
      fetch(`/h5api/system/oss/upload`, {
        method: 'POST',
        body: formData
      }).then(resp => resp.json()).then(resp => {
        var _fileList$value;
        console.log(resp);
        // fileList.value = [...(fileList.value || []), {
        //     url: resp.url,
        //     status: 'done',
        //     message: '上传成功'
        // }]
        const index = (_fileList$value = fileList.value) === null || _fileList$value === void 0 ? void 0 : _fileList$value.findIndex(f => f === file);
        fileList.value[index] = {
          url: resp.data.url,
          status: 'done',
          message: '上传成功'
        };
        // fileList.value = [...fileList.value]
        // fileList.value 
        // file.url = resp.url;
        // file.status = 'done'
        // file.message = '上传成功';
      });
    };
    const onTownConfirm = ({
      selectedValues,
      selectedOptions
    }) => {
      var _selectedOptions$;
      console.log(selectedValues);
      formValue.value = {
        ...formValue.value,
        townCode: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0],
        townName: selectedOptions === null || selectedOptions === void 0 || (_selectedOptions$ = selectedOptions[0]) === null || _selectedOptions$ === void 0 ? void 0 : _selectedOptions$.text
      };
      showTownPicker.value = false;
      FetchHelper.getJson(`/h5api/area/child/${selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0]}`).then(resp => {
        var _resp$data4;
        if ((_resp$data4 = resp.data) !== null && _resp$data4 !== void 0 && _resp$data4.length) {
          var _resp$data5;
          villageColumns.value = (_resp$data5 = resp.data) === null || _resp$data5 === void 0 ? void 0 : _resp$data5.map(item => {
            return {
              text: item.name,
              value: item.shortCode
            };
          });
        }
      });
    };
    const onVillageConfirm = ({
      selectedValues,
      selectedOptions
    }) => {
      var _selectedOptions$2;
      formValue.value = {
        ...formValue.value,
        villageCode: selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues[0],
        villageName: selectedOptions === null || selectedOptions === void 0 || (_selectedOptions$2 = selectedOptions[0]) === null || _selectedOptions$2 === void 0 ? void 0 : _selectedOptions$2.text
      };
      showVillagePicker.value = false;
    };
    const onClsjConfirm = ({
      selectedValues
    }) => {
      formValue.value = {
        ...formValue.value,
        clDate: selectedValues.join('-')
      };
      showClsjPicker.value = false;
    };
    const onFailed = () => {};
    const onSubmit = result => {
      console.log(formValue.value, fileList);
      showLoadingToast({
        message: '提交中...',
        forbidClick: true
      });
      if (id && id !== 'new') {
        var _fileList$value2;
        FetchHelper.putJson(`/h5api/cltb/yakCltb`, {
          ...formValue.value,
          areaCode: formValue.value.villageCode || formValue.value.townCode,
          img: (_fileList$value2 = fileList.value) === null || _fileList$value2 === void 0 ? void 0 : _fileList$value2.map(item => item.url).join(','),
          clDate: dayjs(formValue.value.clDate).format('YYYY-MM-DD HH:mm:ss')
        }).then(e => {
          showSuccessToast('提交成功');
          router.back();
        });
      } else {
        var _fileList$value3;
        FetchHelper.postJson(`/h5api/cltb/yakCltb`, {
          ...formValue.value,
          areaCode: formValue.value.villageCode || formValue.value.townCode,
          img: (_fileList$value3 = fileList.value) === null || _fileList$value3 === void 0 ? void 0 : _fileList$value3.map(item => item.url).join(','),
          clDate: dayjs(formValue.value.clDate).format('YYYY-MM-DD HH:mm:ss')
        }).then(e => {
          showSuccessToast('提交成功');
          router.back();
        });
      }
    };
    return (_ctx, _cache) => {
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_uploader = _resolveComponent("van-uploader");
      const _component_van_cell_group = _resolveComponent("van-cell-group");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_date_picker = _resolveComponent("van-date-picker");
      const _component_van_popup = _resolveComponent("van-popup");
      const _component_van_picker = _resolveComponent("van-picker");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_form, {
        onFailed: onFailed,
        onSubmit: onSubmit,
        style: {
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_unref(type) !== 'detail' ? (_openBlock(), _createBlock(_component_van_cell_group, {
          key: 0,
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: formValue.value.name,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formValue.value.name = $event),
            name: "name",
            label: "姓名",
            placeholder: "请输入姓名"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.idCard,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formValue.value.idCard = $event),
            name: "idCard",
            label: "身份证号",
            placeholder: "请输入身份证号"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.phone,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formValue.value.phone = $event),
            name: "phone",
            label: "联系电话",
            placeholder: "请输入联系电话"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.townName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => formValue.value.townName = $event),
            name: "townName",
            "is-link": "",
            readonly: "",
            label: "所属乡镇",
            placeholder: "请选择所属乡镇",
            onClick: _cache[4] || (_cache[4] = $event => showTownPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.villageName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => formValue.value.villageName = $event),
            name: "villageName",
            label: "所属村",
            "is-link": "",
            readonly: "",
            placeholder: "请选择所属村",
            onClick: _cache[6] || (_cache[6] = $event => showVillagePicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.age,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => formValue.value.age = $event),
            name: "age",
            type: "number",
            label: "出栏年龄",
            placeholder: "请输入出栏年龄"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.number,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => formValue.value.number = $event),
            name: "number",
            type: "number",
            label: "出栏数量",
            placeholder: "请输入出栏数量"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.clDate,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => formValue.value.clDate = $event),
            name: "clDate",
            "is-link": "",
            readonly: "",
            label: "出栏时间",
            placeholder: "点击选择出栏时间",
            onClick: _cache[10] || (_cache[10] = $event => showClsjPicker.value = true)
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            label: "证明凭证"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_uploader, {
              modelValue: fileList.value,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => fileList.value = $event),
              name: "fileList",
              "after-read": afterRead
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _unref(type) === 'detail' ? (_openBlock(), _createBlock(_component_van_cell_group, {
          key: 1,
          inset: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: formValue.value.name,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => formValue.value.name = $event),
            name: "name",
            label: "姓名",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.idCard,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => formValue.value.idCard = $event),
            name: "idCard",
            label: "身份证号",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.phone,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => formValue.value.phone = $event),
            name: "phone",
            label: "联系电话",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.townName,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => formValue.value.townName = $event),
            name: "townName",
            readonly: "",
            label: "所属乡镇"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.villageName,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => formValue.value.villageName = $event),
            name: "villageName",
            label: "所属村",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.age,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => formValue.value.age = $event),
            name: "age",
            type: "number",
            label: "出栏年龄",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.number,
            "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => formValue.value.number = $event),
            name: "number",
            type: "number",
            label: "出栏数量",
            readonly: ""
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            modelValue: formValue.value.clDate,
            "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => formValue.value.clDate = $event),
            name: "clDate",
            readonly: "",
            label: "出栏时间"
          }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
            label: "证明凭证"
          }, {
            input: _withCtx(() => [_createVNode(_component_van_uploader, {
              "show-upload": false,
              modelValue: fileList.value,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => fileList.value = $event),
              readonly: "",
              deletable: false,
              name: "fileList"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _unref(type) !== 'detail' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_button, {
          round: "",
          block: "",
          type: "primary",
          "native-type": "submit"
        }, {
          default: _withCtx(() => [_createTextVNode(" 提交 ")]),
          _: 1
        })])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(_component_van_popup, {
        show: showClsjPicker.value,
        "onUpdate:show": _cache[22] || (_cache[22] = $event => showClsjPicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_date_picker, {
          onConfirm: onClsjConfirm,
          onCancel: _cache[21] || (_cache[21] = $event => showClsjPicker.value = false)
        })]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: showTownPicker.value,
        "onUpdate:show": _cache[23] || (_cache[23] = $event => showTownPicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "选择所属乡镇",
          columns: townColumns.value,
          onConfirm: onTownConfirm
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: showVillagePicker.value,
        "onUpdate:show": _cache[24] || (_cache[24] = $event => showVillagePicker.value = $event),
        position: "bottom"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_picker, {
          title: "选择所属村",
          columns: villageColumns.value,
          onConfirm: onVillageConfirm
        }, null, 8, ["columns"])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};